import React, { Component } from "react";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import textosJSON from "./textosGeneral.json";

const NotFound = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const paths = location.pathname.split("/");
  const pathIdioma = paths.slice(0,2).join("/");
  const pathHome = pathIdioma + "/home";

  const idioma = paths[1];
  const texto = (nombre) => {
    return (textosJSON[nombre]?.[idioma])??(textosJSON[nombre]?.["es"])??""
  }

  useEffect(() => {
    setTimeout(() => {
      navigate(pathHome);
    }, 2500);
  }, []);

  return (
    <React.Fragment>
      <div style={{ height: 80, width: "100%" }} />
      <div
        style={{
          textAlign: "center",
        }}
      >
        <h1 className="tituloError">{texto("404_1")}</h1>
        <h1 className="textoError">{texto("404_2")}</h1>
        <h1 className="textoError">{texto("404_3")}</h1>
      </div>
      <div style={{width: "100%", height: "7vw"}}/>
    </React.Fragment>
  );
};

export default NotFound;
